import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiPutCall, apiGetCall, apiPostCall } from '../utility/site-apis'

const initialState = {
  isFetching: false,
  error: null,
  userDetails: {},
  updateUserSuccess: false,
  tab: 0,
  notifications: [],
  isDelete: false,
}

export const singleUser = createAsyncThunk(
  'user/singleUser',
  async (params, { rejectWithValue }) => {
    const response = await apiGetCall(`/user/${params.id}`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
export const updateUser = createAsyncThunk(
  'user/updateUser',
  async (params, { rejectWithValue }) => {
    const response = await apiPutCall(`/user/profile`, params)
    if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
export const getNotifications = createAsyncThunk(
  'user/getNotifications',
  async (params, { rejectWithValue }) => {
    const response = await apiGetCall(`/notify`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
export const removeNotifications = createAsyncThunk(
  'user/removeNotifications',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(`/notify`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const counterSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setTab: (state, action) => {
      state.tab = action.payload
    },
    setUpdateUserSucces: (state, action) => {
      state.updateUserSuccess = action.payload
    },
  },
  extraReducers: {
    [singleUser.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
    },
    [singleUser.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [singleUser.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.userDetails = action.payload.data
    },
    [updateUser.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.updateUserSuccess = false
    },
    [updateUser.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [updateUser.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.updateUserSuccess = true
      state.userDetails = action.payload.data
    },
    // getNotifications
    [getNotifications.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.notifications = []
    },
    [getNotifications.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [getNotifications.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.notifications = action.payload.data
    },
    // removeNotifications
    [removeNotifications.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.isDelete = false
    },
    [removeNotifications.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [removeNotifications.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.isDelete = true
    },

  }

})

export const { setTab, setUpdateUserSucces } = counterSlice.actions
export default counterSlice.reducer